module.exports = __webpack_public_path__ + "static/media/reza.c3f0d6e5.jpg";